import { render, staticRenderFns } from "./Map4.vue?vue&type=template&id=54e9b25c&scoped=true"
import script from "./Map4.vue?vue&type=script&lang=js"
export * from "./Map4.vue?vue&type=script&lang=js"
import style0 from "./Map4.vue?vue&type=style&index=0&id=54e9b25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9b25c",
  null
  
)

export default component.exports